import { Link, useLocation } from 'react-router-dom';
import { FREE_GAMES } from '../lib/guest';

/** Shown to guests who used up their free games. */
export function SignupWall({ reason = 'games' }: { reason?: 'games' | 'online' }) {
  const here = useLocation().pathname;
  const next = encodeURIComponent(reason === 'online' ? '/play/setup' : here);
  return (
    <div className="page narrow">
      <div className="card stack signup-wall">
        <h1>{reason === 'online' ? 'Create an account to play online' : `You played your ${FREE_GAMES} free games`}</h1>
        <p className="muted">
          {reason === 'online'
            ? 'Matchmaking and your own invite links need an account. It takes ten seconds: a username and a password.'
            : 'Sign up to keep playing. It takes ten seconds: a username and a password. Ratings, history and friends come with it.'}
        </p>
        <div className="row gap wrap">
          <Link to={`/login?mode=signup&next=${next}`} className="btn primary">Sign up</Link>
          <Link to={`/login?next=${next}`} className="btn secondary">Log in</Link>
        </div>
        <p className="muted small">Puzzles and Learn stay free, and you can always join a game a friend invited you to by link.</p>
      </div>
    </div>
  );
}
